import { useTranslation } from '@ecomm/i18n'
import { ComparisonCell } from '../ComparisonCell'
import { ComparisonRow } from '../ComparisonRow'

export function RowAppControlBusiness() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonRow
      title={t('feature-title.app-control-business')}
      description={t('feature-description.app-control-business')}
    >
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
    </ComparisonRow>
  )
}
